var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column flex-1" },
    [
      _c("b-pagination", {
        attrs: { "total-rows": _vm.total, "per-page": _vm.limit },
        on: { input: _vm.pageChanged },
        model: {
          value: _vm.local_page,
          callback: function ($$v) {
            _vm.local_page = $$v
          },
          expression: "local_page",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }